import { z } from 'zod'

export const username = z
  .string()
  .min(3)
  .max(20)
  .toLowerCase()
  .trim()
  .regex(/^[a-zA-Z0-9]+$/, 'Username may only contain alphanumeric characters.')

export const organizationName = z.string().min(2).max(64).trim()

export const displayName = z.string().min(2).max(64).trim()

export const url = z.string().url().or(z.literal(''))
